export const LOCAL_STORAGE_KEY = 'rusty.session';
